import { render, staticRenderFns } from "./BacktopButton.vue?vue&type=template&id=20cc523c&scoped=true&"
import script from "./BacktopButton.vue?vue&type=script&lang=js&"
export * from "./BacktopButton.vue?vue&type=script&lang=js&"
import style0 from "./BacktopButton.vue?vue&type=style&index=0&id=20cc523c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc523c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20cc523c')) {
      api.createRecord('20cc523c', component.options)
    } else {
      api.reload('20cc523c', component.options)
    }
    module.hot.accept("./BacktopButton.vue?vue&type=template&id=20cc523c&scoped=true&", function () {
      api.rerender('20cc523c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Common/BacktopButton.vue"
export default component.exports